module.exports = __webpack_public_path__ + "static/img/sfz.009abfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sfz.png
// module id = 1452
// module chunks = 3